import React from 'react';
import PropTypes from 'prop-types';

const Legend = ({
  data,
  colors
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "chart__legend"
  }, data.map((item, index) => {
    return /*#__PURE__*/React.createElement("div", {
      className: "chart__legend-row",
      key: `legend-${index}`,
      style: {
        width: '100%',
        alignItems: 'center'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "chart__legend-icon",
      style: {
        backgroundColor: colors[index]
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "chart__legend-label"
    }, item.label), /*#__PURE__*/React.createElement("div", {
      className: "chart__legend-line"
    }), /*#__PURE__*/React.createElement("div", {
      className: "chart__legend-value"
    }, item.value));
  }));
};

Legend.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired
  })).isRequired,
  colors: PropTypes.array
};
export default Legend;